import type { BlogPost } from '../context/BlogContext';
import type { PortfolioItem } from '../context/PortfolioContext';
import { language, type Language } from './index';

export interface ContentTranslation {
  title?: string;
  excerpt?: string;
  description?: string;
  content?: string;
  categories?: string[];
  tags?: string[];
  category?: string;
  readTime?: number;
}
export type ContentTranslations = Partial<Record<Language, ContentTranslation>>;

export function isCompleteTranslation(value: ContentTranslation | undefined, kind: 'blog' | 'project'): boolean {
  return !!(value?.title?.trim() && value.content?.trim() &&
    (kind === 'blog' ? value.excerpt?.trim() : value.description?.trim()));
}

export function localizePost(post: BlogPost, target: Language = language): BlogPost {
  const translation = post.translations?.[target];
  if (target === post.sourceLanguage || !isCompleteTranslation(translation, 'blog')) return post;
  const categories = translation?.categories?.map(value => value.trim()).filter(Boolean);
  const tags = translation?.tags?.map(value => value.trim()).filter(Boolean);
  return {
    ...post,
    title: translation!.title!,
    excerpt: translation!.excerpt!,
    content: translation!.content!,
    categories: categories?.length ? categories : post.categories,
    tags: tags?.length ? tags : post.tags,
    readTime: translation!.readTime ?? Math.max(1, Math.ceil(translation!.content!.trim().split(/\s+/).length / 200)),
    contentLanguage: target,
  };
}

export function localizeProject(project: PortfolioItem, target: Language = language): PortfolioItem {
  const translation = project.translations?.[target];
  if (target === project.sourceLanguage || !isCompleteTranslation(translation, 'project')) return project;
  return {
    ...project,
    title: translation!.title!,
    description: translation!.description!,
    longDescription: translation!.content!,
    category: translation!.category || project.category,
    contentLanguage: target,
  };
}
